import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowForm = (flag) => {
        const { setShowForm } = globalStates
        setShowForm(flag)
    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideForm = () => {

        const { FormScreen } = Forms
        const { onResetForm } = FormScreen

        onResetForm()
        handleClickShowForm(false)

    }

    const handleClickFetchAllRates = async () => {

        const { fetchAllRates } = FetchData
        const { executeFetch } = fetchAllRates

        executeFetch()

    }

    const handleClickFetchSpecificRate = async (idrate) => {
        
        const { FormScreen: {onResetForm} } = Forms

        const { fetchSpecificRate } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificRate

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        
        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({idrate: idrate})
        executeFetch()

        handleClickShowForm(true)

    }

    const handleClickEnableDisableRate = async (idrate, estado) => {
        Swal.fire({
            title: '¿Está seguro de Activar este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados de casas que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.post(`/legal/enable-disable-rate`, {idrate, estado})
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllRates()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDeleteRate = async (idrate) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/legal/delete-rate/${idrate}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllRates()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }
    
    const onSubmitForm = async (e) => {

        e.preventDefault()

        const { FormScreen } = Forms
        const { formState, onResetForm } = FormScreen

        const _dataBody = {
            idrate: formState.idrate,
            descripcion: formState.descripcion,
            costo: formState.costo,
            user: user.username
        }

        // console.log('[useActions][onSubmitForm] _dataBody ', _dataBody)

        if(_dataBody.idrate > 0){

            await marvarApi.put( `/legal/update-rate/${_dataBody.idrate}`, _dataBody )
                .then(({ data }) => {

                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllRates()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }else{

            await marvarApi.post( `/legal/create-rate`, _dataBody )
                .then(({ data }) => {
                    
                    alertMessage(data)
                    onResetForm()
                    handleClickFetchAllRates()
                    handleClickHideForm()

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        
        handleClickShowForm,
        handleClickHideForm,
        handleClickFetchAllRates,
        handleClickFetchSpecificRate,
        handleClickEnableDisableRate,
        handleClickDeleteRate,
        onSubmitForm
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}